import { writable, type Writable } from 'svelte/store';
import { browser } from '$app/environment';
import type { UserNotifications } from '../types';
import { getFromLocalStorage, setToLocalStorage } from '@shared/lib';

export const userNotificationsKey = 'USER_NOTIFICATIONS';

const initialValue: UserNotifications = { auctions: {}, artworks: {} };

const createUserNotificationsStore = (key: typeof userNotificationsKey, initValue: UserNotifications) => {
  const { set, update, subscribe }: Writable<UserNotifications> = writable(initValue);

  return {
    subscribe,
    add(key: keyof UserNotifications, id: string, onUpdated?: () => void) {
      update((value) => {
        if (!value[key][id]) {
          if (onUpdated) onUpdated();

          return {
            ...value,
            [key]: { ...value[key], [id]: true },
          };
        }

        return value;
      });
    },
    useLocalStorage() {
      if (!browser) return;

      const json = getFromLocalStorage(key);

      if (json) {
        set(json);
      }

      subscribe((current) => {
        setToLocalStorage(key, current);
      });
    },
  };
};

export const notifications = createUserNotificationsStore(userNotificationsKey, initialValue);
